import { getStringAttributeValue } from '../../../util'
import { Maybe, ProductInterface } from '@pylot-data/fwrdschema'
import { PylotFrontendConfig } from 'config'

/**
 * https://schema.org/alternateName the type is Text, but text value can also be added several times.
 * In a regular HTML schema we can have several elements with the same identifier,
 * while in LD+JSON case we can use an array of strings.
 * In this function we support a case when we need to add several alternate names for a product
 */
export const getAlternateName = (
    product: ProductInterface,
    config: PylotFrontendConfig
): Maybe<Record<string, string[]>> => {
    const alternateNameString = getStringAttributeValue(
        product,
        'alternate_name',
        config
    )
    if (!alternateNameString) {
        return {}
    }
    const alternateNameArray = alternateNameString
        .split(',')
        .map((name: string) => name.trim())
    return { alternateName: alternateNameArray }
}
